<template>
  <div>
    <el-row :gutter="40" class="group">
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="今日入库" icon="pack" color="#40c9c6" :val="dash.pack" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="两月待检" icon="check" color="#E6A23C" :val="dash.check_todo" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="今日复检" icon="recheck" color="#409EFF" :val="dash.recheck" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="col">
        <kx-count title="报废总计" icon="scrap" color="#909399" :val="dash.scrap_all" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import KxCount from '@/components/Count'

export default {
  name: 'DashboardUser',
  components: {
    KxCount
  },
  props: {
    dash: {
      type: Object,
      default() {
        return {}
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 18px;
  .col{
    margin-bottom: 32px;
  }
}
</style>
